// extracted by mini-css-extract-plugin
module.exports = {"root":"Sidebar_root__oVBg_","sidebar":"Sidebar_sidebar__7HBQH","backdrop":"Sidebar_backdrop__f2rUy","cart":"Sidebar_cart__JBTnu"};